"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAttendeeTalkingSelector = void 0;
var _constants = require("@studio/constants");
var isAttendeeTalkingSelector = exports.isAttendeeTalkingSelector = function isAttendeeTalkingSelector(state, attendeeId) {
  var _state$attendeeVoiceI;
  var voiceIntensity = ((_state$attendeeVoiceI = state.attendeeVoiceIntensity) === null || _state$attendeeVoiceI === void 0 ? void 0 : _state$attendeeVoiceI[attendeeId]) || 0;
  return voiceIntensity > _constants.ACTIVE_SPEAKER_INTENSITY_THRESHOLD;
};